import React from 'react';
import { teamMembers, volunteers, Com } from '../data/team';
import TeamMemberCard from '../components/team/TeamMemberCard';
import VolunteerCard from '../components/team/VolunteerCard';

const TeamPage: React.FC = () => {
  return (
    <div className="pt-20">
      <div className="bg-gradient-to-b from-gray-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Our Team</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Meet the passionate individuals who bring EUROPEAN STUDENT to life every day
            </p>
          </div>

          <div className="mb-20">
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Executive Board</h2>
            <div className="grid md:grid-cols-4 gap-8">
              {teamMembers.map((member, index) => (
                <TeamMemberCard key={index} member={member} />
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Our Team</h2>
            <div className="grid md:grid-cols-3 gap-8">
              {volunteers.map((volunteer, index) => (
                <VolunteerCard key={index} volunteer={volunteer} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamPage;